import { Navigate } from 'react-router-dom';

/** Legacy /product/:id URLs → products hub (no standalone code pages). */
const ProductRedirect = () => <Navigate to="/products" replace />;

export default ProductRedirect;
